// extracted by mini-css-extract-plugin
module.exports = {"heading":"_1h9H2tA2p-lhF-lC-EmeNX","downloadBnt":"_16ZwgZ_1RQiMjx8eaehCxB"};